/**
 * This unifies attribute names between:
 * - form entry (basic, ssn) models
 * - prefill fields
 * - redux field names
 */
enum PiiAttributes {
  NameFirst = 'name-first',
  NameMiddle = 'name-middle',
  NameLast = 'name-last',
  NameFull = 'name-full',
  Birthdate = 'birthdate',

  SocialSecurityNumber = 'social-security-number',

  Address = 'address',
  AddressStreet1 = 'address-street-1',
  AddressStreet2 = 'address-street-2',
  AddressCity = 'address-city',
  AddressSubdivision = 'address-subdivision',
  AddressPostalCode = 'address-postal-code',
  AddressCountryCode = 'address-country-code',

  CountryCode = 'country-code',
  PhoneNumber = 'phone-number',
  EmailAddress = 'email-address',

  IdentificationNumber = 'identification-number',
  IdentificationClass = 'identification-class',

  Term = 'term',
}

export default PiiAttributes;
